"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = function useStyles(_ref) {
  var minWidth = _ref.minWidth;
  return (0, _styles.makeStyles)(function (theme) {
    return {
      menuPaper: {
        boxShadow: theme.shadows[2],
        marginTop: theme.spacing(0.75)
      },
      customWidth: {
        minWidth: minWidth
      },
      menuList: {
        boxShadow: theme.shadows[2]
      },
      menuItem: {
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(22),
        color: theme.palette.NEUTRAL800,
        padding: theme.spacing(1, 2),
        '&:hover': {
          backgroundColor: theme.palette.BLUE050
        },
        '&.selected': {
          color: theme.palette.NEUTRAL800,
          fontWeight: 600
        },
        '&.disabled': {
          color: theme.palette.NEUTRAL080,
          pointerEvents: 'none'
        },
        '&.typeForm': {
          padding: theme.spacing(0.5, 2)
        },
        '&.Mui-focusVisible': {
          boxShadow: "inset 0 0 0 2px ".concat(theme.palette.BLUE400),
          backgroundColor: 'transparent',
          boxSizing: 'content-box'
        }
      },
      iconSelected: {
        fontSize: theme.typography.pxToRem(16),
        color: theme.palette.BLUE300,
        marginLeft: theme.spacing(1),
        display: 'flex'
      }
    };
  })();
};
var _default = useStyles;
exports.default = _default;